import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImagineHead: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="imagine-head, thinking, ai"><path d="M15.0603 22.25L15.7863 19.2857C16.6078 16.0921 22.2816 19.1711 19.7026 11.4737L21.25 9.42105C19.8199 8.67673 17.8811 8.12843 17.3382 6.45473C16.6354 4.28804 15.0603 2.75 10.9339 2.75M6.80751 22.25L7.32327 19.6842C7.81016 16.7779 4.16059 14.3288 3.75 11.4737" stroke="currentColor" strokeWidth="1.5"/><path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconImagineHead;
